<section class="cmn-innerpage-wrapper branch">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <div class="viewTabs">
      <div class="viewTabs__child" (click)="changeView(0)">
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M8 9C7.71667 9 7.47934 8.904 7.288 8.712C7.09667 8.52 7.00067 8.28267 7 8C6.99934 7.71733 7.09534 7.48 7.288 7.288C7.48067 7.096 7.718 7 8 7H20C20.2833 7 20.521 7.096 20.713 7.288C20.905 7.48 21.0007 7.71733 21 8C20.9993 8.28267 20.9033 8.52033 20.712 8.713C20.5207 8.90567 20.2833 9.00133 20 9H8ZM8 13C7.71667 13 7.47934 12.904 7.288 12.712C7.09667 12.52 7.00067 12.2827 7 12C6.99934 11.7173 7.09534 11.48 7.288 11.288C7.48067 11.096 7.718 11 8 11H20C20.2833 11 20.521 11.096 20.713 11.288C20.905 11.48 21.0007 11.7173 21 12C20.9993 12.2827 20.9033 12.5203 20.712 12.713C20.5207 12.9057 20.2833 13.0013 20 13H8ZM8 17C7.71667 17 7.47934 16.904 7.288 16.712C7.09667 16.52 7.00067 16.2827 7 16C6.99934 15.7173 7.09534 15.48 7.288 15.288C7.48067 15.096 7.718 15 8 15H20C20.2833 15 20.521 15.096 20.713 15.288C20.905 15.48 21.0007 15.7173 21 16C20.9993 16.2827 20.9033 16.5203 20.712 16.713C20.5207 16.9057 20.2833 17.0013 20 17H8ZM4 9C3.71667 9 3.47934 8.904 3.288 8.712C3.09667 8.52 3.00067 8.28267 3 8C2.99934 7.71733 3.09534 7.48 3.288 7.288C3.48067 7.096 3.718 7 4 7C4.282 7 4.51967 7.096 4.713 7.288C4.90634 7.48 5.002 7.71733 5 8C4.998 8.28267 4.902 8.52033 4.712 8.713C4.522 8.90567 4.28467 9.00133 4 9ZM4 13C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11C4.282 11 4.51967 11.096 4.713 11.288C4.90634 11.48 5.002 11.7173 5 12C4.998 12.2827 4.902 12.5203 4.712 12.713C4.522 12.9057 4.28467 13.0013 4 13ZM4 17C3.71667 17 3.47934 16.904 3.288 16.712C3.09667 16.52 3.00067 16.2827 3 16C2.99934 15.7173 3.09534 15.48 3.288 15.288C3.48067 15.096 3.718 15 4 15C4.282 15 4.51967 15.096 4.713 15.288C4.90634 15.48 5.002 15.7173 5 16C4.998 16.2827 4.902 16.5203 4.712 16.713C4.522 16.9057 4.28467 17.0013 4 17Z"
              fill="#1921b0"
            />
          </svg>
          <span>list</span>
        </button>
      </div>
      <div class="viewTabs__child" (click)="changeView(1)">
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M2 5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5ZM8 5H4V19H8V5ZM10 5V19H14V5H10ZM16 5V19H20V5H16Z"
              fill="#1921b0"
            />
          </svg>

          <span>grid</span>
        </button>
      </div>
    </div>
    <div class="right-set" *ngIf="canCreateLeads$ | async">
      <button class="cmn-add-btn" routerLink="/leads/add">
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Lead
      </button>
    </div>
  </div>

  <div class="leads-noimage-tab-wrapper" *ngIf="activeViewTabIndex === 0">
    <!-- Tabs for statuses -->
    <mat-tab-group
      animationDuration="0ms"
      (selectedTabChange)="onTabChange($event)"
      [selectedIndex]="activeTabIndex"
    >
      <mat-tab *ngFor="let key of leadStatusKeys">
        <ng-template mat-tab-label *ngIf="rawLeadStatusKeys">
          <h2 class="leave-tab-title">
            <span class="tab-title">{{ key === 'All' ? 'All' : getStatusLabel(key) }}</span> 
            <span class="tab-count">
              {{ leadStatusData[key].total ||0}}
            </span>
          </h2>
        </ng-template>

        <div class="inner-content">
          <ag-grid-angular
            style="width: 100%"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowSelection]="rowSelection"
            [suppressRowClickSelection]="true"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [class]="themeClass"
            (cellClicked)="onCellClicked($event, 'list')"
          >
          </ag-grid-angular>
        </div>

        <div class="pagination-wrapper">
          <div class="page-size">
            <label for="pageSize">Page Size:</label>
            <select
              id="pageSize"
              [(ngModel)]="pageSize"
              (change)="onPageSizeChange($event)"
            >
              <option *ngFor="let size of pageSizeOptions" [value]="size">
                {{ size }}
              </option>
            </select>
          </div>

          <!-- Pagination controls using leadStatusData -->
          <div class="page-nav" 
               *ngIf=" totalPage > 1">
            <button class="prev" (click)="prevPage()" [disabled]="page === 0">
              <img
                src="../../../assets/images/icons/arrow.svg"
                alt="prev arrow"
              />
            </button>
            <span>
              Page {{ page + 1 }} of {{totalPage}}
            </span>
            <button
              class="next"
              (click)="nextPage()"
              [disabled]="page + 1 >= totalPage "
            >
              <img
                src="../../../assets/images/icons/arrow.svg"
                alt="next arrow"
              />
            </button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div
    class="kanban-board"
    style="display: flex; gap: 16px; align-items: flex-start"
    *ngIf="activeViewTabIndex === 1"
  >
    <div
      *ngFor="let status of rawLeadStatusKeys"
      cdkDropList
      #dropList="cdkDropList"
      [attr.data-status]="status"
      [cdkDropListData]="getLeadsByStatus(status)"
      [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="drop($event, status)"
      class="drag-container"
    >
      <div class="status-wrapper">
        <h3 class="statusLabel">{{ getStatusLabel(status) }}</h3>

        <span>{{ leadStatusData[status].total ||0}}</span>
      </div>

      <div
        *ngFor="let lead of getLeadsByStatus(status)"
        cdkDrag
        (click)="onCellClicked(lead, 'grid')"
        class="dragable-item"
        style="
          background: #fff;
          margin-bottom: 8px;
          padding: 10px 10px 10px 10px;
          border-radius: 4px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.106),
            0 2px 4px -2px rgba(0, 0, 0, 0.106);
          position: relative;
          overflow: hidden;
        "
      >
        <div class="leadData">
          <h5
            style="
              color: #000;
              font-size: 1.1rem;
              font-weight: 500;
              margin-bottom: 5px;
              text-transform: capitalize;
            "
          >
            {{ lead.leadName }}
          </h5>
          <h6 style="color: #000; font-size: 0.9rem; font-weight: 400">
            {{ lead.companyName }}
          </h6>
        </div>

        <div
          style="
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;
          "
        >
          <div
            style="
              width: 30px;
              aspect-ratio: 1;
              border-radius: 100px;
              overflow: hidden;
            "
          >
            <img
              style="width: 100%; object-fit: cover; object-position: center"
              src="../../../assets/images/dummy-profile-image.jpg"
            />
          </div>
          <h6 style="color: #000; font-size: 0.8rem; font-weight: 400">
            {{ lead.assignedTo }}
          </h6>
        </div>

        <div
          style="
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            position: absolute;
            right: 10px;
            bottom: -100%;
            transition: 0.3s ease-in-out;
          "
          class="actionWrapper"
        >
          <div
            style="
              background-color: #c11c1c;
              padding: 5px;
              border-radius: 5px;
              cursor: pointer;
            "
            (click)="onDeleteLead(lead.id); $event.stopPropagation()"
            class="deleteWrapper"
            *ngIf="canDeleteLeads$ | async"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="auto"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                fill="#fff"
              />
            </svg>
          </div>

          <div
            style="
              background-color: #299764;
              padding: 5px;
              border-radius: 5px;
              cursor: pointer;
            "
            (click)="openEdit(lead); $event.stopPropagation()"
            class="editWrapper"
            *ngIf="canEditLeads$ | async"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="auto"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.3751 2.62523C18.7729 2.2274 19.3125 2.00391 19.8751 2.00391C20.4377 2.00391 20.9773 2.2274 21.3751 2.62523C21.7729 3.02305 21.9964 3.56262 21.9964 4.12523C21.9964 4.68784 21.7729 5.2274 21.3751 5.62523L12.3621 14.6392C12.1246 14.8765 11.8313 15.0501 11.5091 15.1442L8.63609 15.9842C8.55005 16.0093 8.45883 16.0108 8.372 15.9886C8.28517 15.9663 8.20592 15.9212 8.14254 15.8578C8.07916 15.7944 8.03398 15.7151 8.01174 15.6283C7.98949 15.5415 7.991 15.4503 8.01609 15.3642L8.85609 12.4912C8.95062 12.1693 9.12463 11.8763 9.36209 11.6392L18.3751 2.62523Z"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
